export default __webpack_public_path__ + "6364af07f108ff9f8f08fbe380ff14be.woff?proxy=wpt-abc";